import React from 'react';
import TABLE from '../table';

const TABLEPAGINADA = ({
    header,
    body = [],
    foot,
    onRowClick,
    count = 0,
    page = 0,
    maxitens = 50,
    pages = 0,
    onPageChange,
    maxButtons = 5,
    showCount = true
}) => {
    const clampedPage = Math.max(0, Math.min(Number(page) || 0, Math.max(pages - 1, 0)));
    const startIndex = count === 0 ? 0 : clampedPage * maxitens + 1;
    const endIndex = count === 0 ? 0 : Math.min((clampedPage + 1) * maxitens, count);

    // Verifica se pode ir para próxima página comparando com total de páginas
    const canGoPrev = clampedPage > 0;
    const canGoNext = pages > 0 && clampedPage < pages - 1;

    const handleChange = (nextPage) => {
        if (!onPageChange || nextPage === clampedPage) {
            return;
        }
        onPageChange(nextPage);
    };

    const half = Math.floor(maxButtons / 2);
    let start = Math.max(0, clampedPage - half);
    let end = Math.min(pages, start + maxButtons);
    start = Math.max(0, end - maxButtons);

    const pageNumbers = [];
    for (let p = start; p < end; p += 1) {
        pageNumbers.push(p);
    }

    return (
        <div className="row">
            <TABLE
                header={header}
                body={body}
                foot={foot}
                onRowClick={onRowClick}
            />
            <div className="d-flex flex-wrap align-items-center justify-content-between ms-5 me-5 mt-2">
                {showCount && (
                    <div className="small text-muted">
                        {count === 0 ? 'Sem registros' : `Mostrando ${startIndex}-${endIndex} de ${count}`}
                    </div>
                )}
                {pages > 1 && (
                    <nav aria-label="Paginacao">
                        <ul className="pagination mb-0">
                            <li className={`page-item ${!canGoPrev ? 'disabled' : ''}`}>
                                <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => handleChange(0)}
                                    disabled={!canGoPrev}
                                >
                                    Primeiro
                                </button>
                            </li>
                            <li className={`page-item ${!canGoPrev ? 'disabled' : ''}`}>
                                <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => handleChange(clampedPage - 1)}
                                    disabled={!canGoPrev}
                                >
                                    Anterior
                                </button>
                            </li>
                            {pageNumbers.map((p) => (
                                <li key={p} className={`page-item ${p === clampedPage ? 'active' : ''}`}>
                                    <button
                                        type="button"
                                        className="page-link"
                                        onClick={() => handleChange(p)}
                                    >
                                        {p + 1}
                                    </button>
                                </li>
                            ))}
                            <li className={`page-item ${!canGoNext ? 'disabled' : ''}`}>
                                <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => handleChange(clampedPage + 1)}
                                    disabled={!canGoNext}
                                >
                                    Proximo
                                </button>
                            </li>
                            <li className={`page-item ${!canGoNext ? 'disabled' : ''}`}>
                                <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => handleChange(pages - 1)}
                                    disabled={!canGoNext}
                                >
                                    Ultimo
                                </button>
                            </li>
                        </ul>
                    </nav>
                )}
            </div>
        </div>
    );
};

export default TABLEPAGINADA;

/**
 * Exemplo de uso com API que retorna:
 * { page: 0, maxitens: 50, count: 22064, pages: 442, dados: [...] }
 * 
 * const [tableData, setTableData] = useState({ 
 *   page: 0, 
 *   maxitens: 50, 
 *   count: 0, 
 *   pages: 0, 
 *   dados: [] 
 * });
 * 
 * const handleFetch = async (pagina) => {
 *   const res = await api.get(`/endpoint?page=${pagina}`);
 *   setTableData(res.data);
 * };
 * 
 * <TablePaginada
 *   header={['#', 'Nome', 'Email']}
 *   body={tableData.dados}
 *   count={tableData.count}
 *   page={tableData.page}
 *   maxitens={tableData.maxitens}
 *   pages={tableData.pages}
 *   onPageChange={handleFetch}
 * />
 */
